export default "__VITE_ASSET__DQ7PnJVi__"